<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { RouterLink } from 'vue-router'
import type { RouteLocationRaw } from 'vue-router'

interface Props {
  /** The header text */
  header: string
  /** Optional route for edit link */
  route?: RouteLocationRaw | null
}

const { route = null } = defineProps<Props>()

defineOptions({
  name: 'SummaryContainer'
})

const { t } = useI18n()
</script>

<template>
  <section class="rounded-md border border-secondary-200">
    <header
      class="flex items-center justify-between gap-x-3 rounded-t-md border-b bg-secondary-50 p-4 font-medium"
    >
      <slot :header name="heading">
        <h3 class="text-sm">{{ header }}</h3>
      </slot>
      <RouterLink v-if="route" class="text-primary" :to="route">
        {{ t('general.edit') }}
      </RouterLink>
    </header>

    <div
      class="summary-container-content w-full divide-y-2 divide-dashed divide-gray-200"
    >
      <slot />
    </div>
  </section>
</template>

<style lang="scss" scoped>
@reference '../../../styles/main.css';

.summary-container-content > * {
  @apply py-3 px-4;
}
</style>
